<template>
  <div class="home">
    <img
      alt="ss logo"
      src="https://cdn.samsung.com/etc/designs/smg/global/imgs/svg-logo.svg">
    <h1>login</h1>
    <section class="input-section">
      <b-field
        label="Email">
        <b-input
          v-model="email" />
      </b-field>
      <b-field
        label="Wachtwoord">
        <b-input
          v-model="password"
          type="password" />
      </b-field>
      <b-button
        type="is-primary"
        @click="submit">
        Login
      </b-button>
    </section>
  </div>
</template>

<script>
export default {
  name: "Login",
  components: {},
  data() {
    return {
      email: "",
      password: ""
    };
  },
  methods: {
    submit() {
      this.$store.dispatch("userJoin", {
        email: this.email,
        password: this.password
      });
    }
  }
};
</script>

<style lang="scss" scoped>
h1 {
  font-size: 2rem;
  margin: 1rem 0;
}
</style>




